import { StepName } from '../../stepMap';
import { CoverageCheckupState } from '../step';
import { RootState } from '../store';

// If you are editing this file be sure you have read and understand these docs:
// https://gitlab.com/ramsey-solutions/trusted/rt-protections/frontman-app/-/blob/cb6c5393f267222692a3d22d1ab998f7fabfeb3c/packages/coverage-checkup/src/store/selectors/documentation

export function selectStepOrder(state: RootState): StepName[] {
  const steps = state.steps;
  return [
    'AgeStep',
    'MarriageStep',
    'DependentsStep',
    'EmploymentStatusStep',
    'LivingSituationStep',
    'IncomeStep',
    'NonRetirementSavingsStep',
    'RetirementSavingsStep',
    ...selectHomeEquitySteps(steps),
    'OwnACarStep',
    ...selectAutoInsuranceStep(steps),
    ...selectAutoInsuranceDetailsStep(steps),
    ...selectHomeOrRentersInsuranceSteps(steps),
    ...selectHomeOrRentersInsuranceDetailsSteps(steps),
    'HealthInsuranceStep',
    ...selectHealthInsuranceSteps(steps),
    'LifeInsuranceStep',
    ...selectLifeInsuranceTypeStep(steps),
    ...selectLifeInsuranceDetailsStep(steps),
    'DisabilityInsuranceStep',
    ...selectDisabilityInsuranceTypeStep(steps),
    ...selectDisabilityInsuranceDetailsStep(steps),
    'LongTermCareInsuranceStep',
    'UmbrellaInsuranceStep',
    ...selectUmbrellaInsuranceDetailsStep(steps),
    'IdentityTheftProtectionStep',
    ...selectIdentityTheftProtectionDetailsStep(steps),
    'LastWillStep',
    ...selectLastWillStateStep(steps),
    ...selectLastWillDetailsStep(steps),
    'CreditReportStep',
    'SeparateInsurancePoliciesStep',
    'UserInformationStep',
    'GetMyResultsStep',
  ];
}
export function selectCurrentStepName(state: RootState): StepName {
  const currentSteps = selectStepOrder(state);
  return currentSteps[state.steps.currentStepIndex];
}

function selectAutoInsuranceStep(steps: CoverageCheckupState): StepName[] {
  if (steps.carOwned === 'yes') {
    return ['AutoInsuranceStep'];
  }
  return [];
}
function selectAutoInsuranceDetailsStep(
  steps: CoverageCheckupState
): StepName[] {
  if (steps.autoInsurancePossessed === 'yes') {
    return ['AutoInsuranceDetailsStep'];
  }
  return [];
}

function selectHomeEquitySteps(steps: CoverageCheckupState): StepName[] {
  if (steps.livingSituation === 'homeowner') {
    return ['HomeValueStep', 'MortgageStep'];
  }
  return [];
}

function selectHomeOrRentersInsuranceSteps(
  steps: CoverageCheckupState
): StepName[] {
  if (steps.livingSituation === 'homeowner') {
    return ['HomeOwnersInsuranceStep'];
  }

  if (steps.livingSituation === 'renter') {
    return ['RentersInsuranceStep'];
  }
  return [];
}

function selectHomeOrRentersInsuranceDetailsSteps(
  steps: CoverageCheckupState
): StepName[] {
  if (
    steps.livingSituation === 'homeowner' &&
    steps.homeownersInsurancePossessed === 'yes'
  ) {
    return ['HomeownersInsuranceDetails'];
  }
  if (
    steps.livingSituation === 'renter' &&
    steps.homeownersInsurancePossessed === 'yes'
  ) {
    return ['RentersInsuranceDetailsStep'];
  }
  return [];
}

function selectHealthInsuranceSteps(steps: CoverageCheckupState): StepName[] {
  if (steps.healthInsurancePossessed === 'yes') {
    return ['HighDeductiblePlanStep', 'HealthInsuranceDetailsStep'];
  }
  return [];
}

function selectLifeInsuranceTypeStep(steps: CoverageCheckupState): StepName[] {
  if (steps.lifeInsurancePossessed === 'yes') {
    return ['LifeInsuranceTypeStep'];
  }
  return [];
}

function selectLifeInsuranceDetailsStep(
  steps: CoverageCheckupState
): StepName[] {
  if (steps.typeOfLifeInsurancePossessed === 'term') {
    return ['LifeInsuranceDetailsStep'];
  }
  return [];
}

function selectDisabilityInsuranceTypeStep(
  steps: CoverageCheckupState
): StepName[] {
  if (steps.disabilityInsurancePossessed === 'yes') {
    return ['DisabilityInsuranceTypeStep'];
  }
  return [];
}

function selectDisabilityInsuranceDetailsStep(
  steps: CoverageCheckupState
): StepName[] {
  if (
    steps.typeOfDisabilityInsurancePossessed === 'both' ||
    steps.typeOfDisabilityInsurancePossessed === 'long_term'
  ) {
    return ['DisabilityInsuranceDetailsStep'];
  }
  return [];
}

function selectUmbrellaInsuranceDetailsStep(
  steps: CoverageCheckupState
): StepName[] {
  if (steps.umbrellaInsurancePossessed === 'yes') {
    return ['UmbrellaInsuranceDetailsStep'];
  }
  return [];
}

function selectIdentityTheftProtectionDetailsStep(
  steps: CoverageCheckupState
): StepName[] {
  if (steps.identityTheftProtectionPossessed === 'yes') {
    return ['IdentityTheftProtectionDetailsStep'];
  }
  return [];
}

function selectLastWillStateStep(steps: CoverageCheckupState): StepName[] {
  if (steps.willPossessed === 'yes') {
    return ['LastWillStateStep'];
  }
  return [];
}

function selectLastWillDetailsStep(steps: CoverageCheckupState): StepName[] {
  if (steps.willPurchasedInSameStateAsResidence === 'yes') {
    return ['LastWillDetailsStep'];
  }
  return [];
}
